'use client';

import AppImage from './components/ui/AppImage';
import FacilitiesSection from './components/screens/home/FacilitiesSection';
import Footer from './components/common/Footer';
import Header from './components/common/Header';
import HeroSection from './components/screens/home/HeroSection';
import Icon from './components/ui/AppIcon';
import Link from 'next/link';
import NewsTestimonialsSection from './components/screens/home/NewsTestimonialsSection';
import ServicesSection from './components/screens/home/ServicesSection';
import TeamSection from './components/screens/home/TeamSection';
import { ThemeToggle } from './components/common/ThemeToggle';
import TransformingVisitsSection from './components/screens/home/TransformingVisitsSection';
import { AppointmentBookingHost } from './components/appointments/AppointmentBookingHost';
import { useEffect } from 'react';

export default function Homepage() {
  // Scroll reveal effect
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach(el => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <div className="min-h-screen bg-background">
      {/* Theme Toggle - Fixed Position */}
      <Header />

      {/* Hero Section */}
      <HeroSection />

      {/* Transforming Visits Section */}
      <TransformingVisitsSection />

      {/* Services Section */}
      <ServicesSection />

      {/* Facilities Section */}
      <FacilitiesSection />

      {/* Team Section */}
      {/* <TeamSection /> */}

      {/* News & Testimonials Section */}
      <NewsTestimonialsSection />

      {/* Footer */}
      <Footer />

      <AppointmentBookingHost />
    </div>
  )
}